import React, { useEffect, useState } from "react";
import { FaSearch, FaRegBuilding, FaHouseUser } from "react-icons/fa";
import { GrLocationPin } from "react-icons/gr";
import apiClient from "../api.js";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaLocationDot, FaIndianRupeeSign } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Autoplay } from "swiper/modules";
import "swiper/css/bundle";
import Popup from "../components/Popup.jsx";
import Canonical from "../components/Canonical.js";
import Testimonial from "../components/Testimonial.jsx";
import BuilderSlider from "../components/BuilderSlider.jsx";
import WhyChooseUs from "../components/WhyChooseUs.jsx";

const Home = () => {
  const [name, setname] = useState("");
  const [areaDefault, setAreaDefault] = useState(false);
  const [results, setResults] = useState([]);
  const [regionProperty, setregionProperty] = useState([]);
  const [regionCommercial, setregionCommercial] = useState([]);
  const [discountedProperty, setdiscountedProperty] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const isPlotPage = location.pathname === "/";

  useEffect(
    (area) => {
      getArea(area);
      getPropertyDiscountedDeal();

      const delayDebounceFn = setTimeout(() => {
        if (name) {
          fetchSearchResults(name);
        } else {
          setResults([]); // Clear results if name is empty
        }
      }, 300); // 300ms debounce

      return () => clearTimeout(delayDebounceFn);
    },
    [name],
  );

  const fetchSearchResults = async (term) => {
    setLoading(true);
    try {
      const response = await apiClient.post("listing/search", {
        name: term,
      });

      const properties = response.data;

      setResults(properties);
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setname(e.target.value);
  };

  const getPropertyByRegion = async (area) => {
    try {
      if (areaDefault === false) {
        const area = "Western Suburbs";
        const response = await apiClient.get(
          `listing/regionpropertyfordisplay/${encodeURIComponent(area)}`,
        );
        setregionProperty(response.data);
      } else {
        const response = await apiClient.get(
          `listing/regionpropertyfordisplay/${encodeURIComponent(area)}`,
        );
        setregionProperty(response.data);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };
  const getCommercialByRegion = async (area) => {
    try {
      if (areaDefault === false) {
        const area = "Western Suburbs";
        const response = await apiClient.get(
          `listing/regioncommercialfordisplay/${encodeURIComponent(area)}`,
        );
        setregionCommercial(response.data);
      } else {
        const response = await apiClient.get(
          `listing/regioncommercialfordisplay/${encodeURIComponent(area)}`,
        );
        setregionCommercial(response.data);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const areas = [
    "Western Suburbs",
    "Eastern Suburbs",
    "Churchgate",
    "South Bombay",
    "Navi Mumbai",
    "Kalyan Dombivli",
    "Ambernath Badlapur",
    "Vasai Virar Naigaon",
    "Thane",
    "Palghar",
  ];

  const [activeArea, setActiveArea] = useState(areas[0]);

  useEffect(() => {
    getArea(areas[0]);
    getCommercialByRegion(areas[0]);
  }, []);

  const getArea = async (area) => {
    setActiveArea(area);
    setLoading(true);
    setAreaDefault(true);
    getPropertyByRegion(area);
    getCommercialByRegion(area);
  };

  const getPropertyDiscountedDeal = async (area) => {
    try {
      const responseDiscounted = await apiClient.get(
        `listing/discountedproperty`,
      );
      if (responseDiscounted) {
        setdiscountedProperty(responseDiscounted.data);
        // console.log(responseDiscounted.data);
        // console.log(discountedProperty);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  // handle popup button
  const [popupData, setPopupData] = useState("");

  const handleButtonClick = (dataName) => {
    // console.log(dataName);
    setPopupData(dataName);
  };

  const navigate = useNavigate();
  const handleCityChange = (e) => {
    if (e.target.value === "pune") {
      navigate("/pune");
    }
    // If you want to handle Mumbai, you can add logic here
  };

  const getDisplaySubregion = (subregion) => {
    if (subregion === "Dombivali") return "Dombivli";
    else if (subregion === "Vikroli") return "Vikhroli";
    else if (subregion === "Vadala") return "Wadala";
    else return subregion;
  };

  const canonicalUrl = "https://homesdekho.com/";
  const hrfLangTag = "https://homesdekho.com/";
  const title = "Buy Property in Mumbai | Flats & Homes for Sale - Homes Dekho";
  const description =
    "Discover the best flats in Mumbai with Homes Dekho. Check out verified listings, compare prices, and find your perfect home in top Mumbai locations. Enquire now!";

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={title}
        hrfLang={hrfLangTag}
        description={description}
      />

      <section className="banner-img">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="input-wrapper-top margin-search-bar">
                <div
                  className={`active-input-type-residentials-home ${
                    isPlotPage ? "" : "active-input-type-residential-home"
                  }`}
                >
                  <Link to="/">Residential / Commercial</Link>
                </div>
                <div
                  className={`active-input-type-plotss-home ${
                    isPlotPage ? "active-input-type-plots-home" : ""
                  }`}
                >
                  <Link to="/plot">Plots</Link>
                </div>
              </div>
              <div className="input-wrapper text-center">
                <select
                  className="select-city"
                  aria-label="Default select example"
                  onChange={handleCityChange}
                  defaultValue="mumbai"
                >
                  <option value="mumbai">Mumbai</option>
                  <option value="pune">Pune</option>
                </select>

                <FaSearch className="search-icon" />
                <input
                  value={name}
                  onChange={handleChange}
                  id="searchPropertyInput"
                  className="search-input"
                  placeholder="Location, Property, Developer"
                />
                <button onClick={fetchSearchResults} className="search-btn">
                  Search
                </button>
              </div>
              <div
                className="col-md-"
                style={
                  loading === false ? { display: "block" } : { display: "none" }
                }
              >
                {loading && <p className="text-center">Loading...</p>}

                <div className="search-result-div">
                  {results.map((result) => {
                    if (result.matchedField === "name") {
                      if (result.propertytype === "commercial") {
                        return (
                          <Link
                            className="search-link"
                            to={`commercial/property-detail/${result.slug}`}
                          >
                            <div
                              key={result._id}
                              className="inner-search-result-div"
                            >
                              <div className="building-icon-div">
                                <FaRegBuilding className="building-icon" />
                              </div>
                              <div className="project-name-div">
                                <p className="project-name-real">
                                  {result.name}
                                </p>{" "}
                                <p className="project-name-txt">Project Name</p>
                              </div>
                            </div>
                          </Link>
                        );
                      } else {
                        return (
                          <Link
                            className="search-link"
                            to={`property-detail/${result.slug}`}
                          >
                            <div
                              key={result._id}
                              className="inner-search-result-div"
                            >
                              <div className="building-icon-div">
                                <FaRegBuilding className="building-icon" />
                              </div>
                              <div className="project-name-div">
                                <p className="project-name-real">
                                  {result.name}
                                </p>{" "}
                                <p className="project-name-txt">Project Name</p>
                              </div>
                            </div>
                          </Link>
                        );
                      }
                    } else if (result.matchedField === "address") {
                      return (
                        <Link
                          className="search-link"
                          to={`propertiesbyregion/${result.subregion.replace(
                            /\s+/g,
                            "-",
                          )}`}
                        >
                          <div
                            key={result._id}
                            className="inner-search-result-div"
                          >
                            <div className="building-icon-div">
                              <GrLocationPin className="building-icon" />
                            </div>
                            <div className="project-name-div">
                              <p className="project-name-real">
                                {(() => {
                                  if (result.subregion === "Dombivali")
                                    return "Dombivli";
                                  if (result.subregion === "Vikroli")
                                    return "Vikhroli";
                                  if (result.subregion === "Vadala")
                                    return "Wadala";
                                  return result.subregion;
                                })()}

                                {/* {result.subregion} */}
                              </p>{" "}
                              <p className="project-name-txt">
                                Project Address
                              </p>
                            </div>
                          </div>
                        </Link>
                      );
                    } else if (result.matchedField === "devlopername") {
                      return (
                        <Link
                          className="search-link"
                          to={`projects/${result.devlopername.replace(
                            /\s+/g,
                            "-",
                          )}`}
                        >
                          <div
                            key={result._id}
                            className="inner-search-result-div"
                          >
                            <div className="building-icon-div">
                              <FaHouseUser className="building-icon" />
                            </div>
                            <div className="project-name-div">
                              <p className="project-name-real">
                                {result.devlopername}
                              </p>{" "}
                              <p className="project-name-txt"></p>
                            </div>
                          </div>
                        </Link>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            </div>
            <div className="col-md-6 d-none d-md-block">
              <div className="banner-txt-div">
                <div>
                  <h1 className="banner-heading">
                    Find Your <span>Dream</span> Home in <span>Mumbai</span>
                  </h1>
                  <p className="banner-subheading">
                    Take the next step to buy a home in Mumbai - Modern,
                    affordable, and hassle-free. Discover residential properties
                    with top amenities and seamless connectivity. Get the best
                    flats in Mumbai on the trusted HomesDekho real estate
                    portal.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-region-section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="banner-heading-h2">
                Explore Properties by Location
              </h2>
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                slidesPerView={"auto"} // Force 8 slides to fit within the first view
                modules={[FreeMode, Navigation]}
                navigation={true}
                style={{
                  padding: "10px 0px", // Padding around text
                }}
              >
                {areas.map((area, index) => (
                  <SwiperSlide
                    key={area}
                    className="area-name-slider"
                    onClick={() => getArea(area)}
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "200px",
                      padding: "10px 20px", // Padding around text
                      background: area === activeArea ? "#032B5F" : "#ffffff", // Highlight the first slide
                      color: area === activeArea ? "#FFFFFF" : "#000000",
                      border: "1px solid #032B5F",
                      borderRadius: "20px", // Rounded corners
                      whiteSpace: "nowrap", // Prevent text wrapping
                      flexShrink: 0, // Prevent slides from shrinking
                    }}
                  >
                    <div>{area}</div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* region vise porperty */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                freeMode={true} // Enable free scrolling
                navigation={true}
                modules={[FreeMode, Navigation]}
                style={{ padding: "10px 0" }}
                breakpoints={{
                  425: {
                    slidesPerView: 1, // Show 2 slides on small screens
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 2, // Show 4 slides on tablets
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 1.5, // Show based on content on larger screens
                    spaceBetween: 20,
                  },
                }}
              >
                {Object.entries(regionProperty, regionProperty._id).map(
                  ([subregion, properties]) => (
                    <SwiperSlide key={regionProperty._id}>
                      <div className="hoomepage-region-main-div">
                        <div className="region-name-div-for-homepage">
                          <p className="regiona-name-txt">
                            Homes In {getDisplaySubregion(subregion)}
                          </p>
                        </div>
                        <div className="top-projects-div">
                          <p className="top-projects-txt">
                            Top Projects In {getDisplaySubregion(subregion)}
                          </p>
                        </div>
                        <div className="row">
                          <Swiper
                            className="region-button"
                            spaceBetween={10} // Space between slides
                            modules={[FreeMode, Autoplay]}
                            autoplay={{
                              delay: 2000, // Delay between slides in milliseconds (e.g., 2 seconds)
                              disableOnInteraction: false, // Allow autoplay to continue even after user interaction
                            }}
                            style={{ padding: "10px 10px" }}
                            breakpoints={{
                              425: {
                                slidesPerView: 1, // Show 2 slides on small screens
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 2, // Show 4 slides on tablets
                                spaceBetween: 15,
                              },
                              1024: {
                                slidesPerView: 3, // Show based on content on larger screens
                                spaceBetween: 20,
                              },
                            }}
                          >
                            {properties.slice(0, 3).map((property, index) => (
                              <div className="col-md-12">
                                <SwiperSlide key={index}>
                                  <Link
                                    to={`/property-detail/${property.slug}`}
                                    className="property-region-link"
                                  >
                                    <div className="homepage-property-main-div">
                                      <div>
                                        <img
                                          className="img-fluid property-img-region"
                                          src={property.imageUrls}
                                          alt={property.name}
                                        />
                                        <p className="property-name-txt-inner-for-regions">
                                          {property.name}
                                        </p>

                                        <p className="property-name-txt-inner-for-region">
                                          {property.BHK &&
                                          Array.isArray(property.BHK) ? (
                                            property.BHK.map((bhk, idx) => (
                                              <span key={idx}>
                                                {bhk}
                                                {bhk === "Studio" ? "" : " BHK"}
                                                {idx <
                                                  property.BHK.length - 1 &&
                                                  ", "}
                                              </span>
                                            ))
                                          ) : (
                                            <span>Loading data...</span>
                                          )}
                                        </p>
                                        <p className="property-price-range-region-vise">
                                          {property.price}
                                        </p>
                                      </div>
                                    </div>
                                  </Link>
                                </SwiperSlide>
                              </div>
                            ))}
                          </Swiper>
                          <p className="view-more-link-by-subregion">
                            <Link
                              to={`propertiesbyregion/${subregion.replace(
                                /\s+/g,
                                "-",
                              )}`}
                            >
                              View more Properties in{" "}
                              {getDisplaySubregion(subregion)}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ),
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* region vise porperty  */}
      {/* Commercial Property Section */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                freeMode={true} // Enable free scrolling
                navigation={true}
                modules={[FreeMode, Navigation]}
                style={{ padding: "10px 0" }}
                breakpoints={{
                  425: {
                    slidesPerView: 1, // Show 2 slides on small screens
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 2, // Show 4 slides on tablets
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 1.5, // Show based on content on larger screens
                    spaceBetween: 20,
                  },
                }}
              >
                {Object.entries(regionCommercial, regionCommercial._id).map(
                  ([subregion, commercials]) => (
                    <SwiperSlide key={regionCommercial._id}>
                      <div className="hoomepage-region-main-div">
                        <div className="region-name-div-for-homepage">
                          <p className="regiona-name-txt">
                            Commercial Spaces in{" "}
                            {getDisplaySubregion(subregion)}
                          </p>
                        </div>
                        <div className="top-projects-div">
                          <p className="top-projects-txt">
                            Top Projects In {getDisplaySubregion(subregion)}
                          </p>
                        </div>
                        <div className="row">
                          <Swiper
                            className="region-button"
                            spaceBetween={10} // Space between slides
                            modules={[FreeMode, Autoplay]}
                            autoplay={{
                              delay: 2000, // Delay between slides in milliseconds (e.g., 2 seconds)
                              disableOnInteraction: false, // Allow autoplay to continue even after user interaction
                            }}
                            style={{ padding: "10px 10px" }}
                            breakpoints={{
                              425: {
                                slidesPerView: 1, // Show 2 slides on small screens
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 2, // Show 4 slides on tablets
                                spaceBetween: 15,
                              },
                              1024: {
                                slidesPerView: 3, // Show based on content on larger screens
                                spaceBetween: 20,
                              },
                            }}
                          >
                            {commercials
                              .slice(0, 3)
                              .map((commercial, index) => (
                                <div className="col-md-12">
                                  <SwiperSlide key={index}>
                                    <Link
                                      to={`/commercial/property-detail/${commercial.slug}`}
                                      className="property-region-link"
                                    >
                                      <div className="homepage-property-main-div">
                                        <div>
                                          <img
                                            className="img-fluid property-img-region"
                                            src={commercial.imageUrls}
                                            alt={commercial.name}
                                          />
                                          <p className="property-name-txt-inner-for-regions">
                                            {commercial.name}
                                          </p>
                                          <p className="property-name-txt-inner-for-region">
                                            {commercial.BHK &&
                                            Array.isArray(commercial.BHK) ? (
                                              commercial.BHK.map((bhk, idx) => (
                                                <span key={idx}>
                                                  {bhk}
                                                  {idx <
                                                    commercial.BHK.length - 1 &&
                                                    ", "}
                                                </span>
                                              ))
                                            ) : (
                                              <span>Loading data...</span>
                                            )}
                                          </p>
                                          <p className="property-price-range-region-vise">
                                            {commercial.price}
                                          </p>
                                        </div>
                                      </div>
                                    </Link>
                                  </SwiperSlide>
                                </div>
                              ))}
                          </Swiper>
                          <p className="view-more-link-by-subregion">
                            <Link
                              to={`commercialproperties/${subregion.replace(
                                /\s+/g,
                                "-",
                              )}`}
                            >
                              View more Properties in{" "}
                              {getDisplaySubregion(subregion)}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ),
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* Commercial Property Section */}

      {/* discounted deals  */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Discounted Deals</p>
            </div>
            <Swiper
              className="region-button"
              spaceBetween={10} // Space between slides
              modules={[FreeMode, Autoplay, Navigation]}
              navigation={true}
              autoplay={{
                delay: 2000, // Delay between slides in milliseconds (e.g., 3 seconds)
                disableOnInteraction: false, // Allow autoplay to continue even after user interaction
              }}
              style={{ padding: "10px 10px" }}
              breakpoints={{
                425: {
                  slidesPerView: 1, // Show 2 slides on small screens
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2, // Show 4 slides on tablets
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3, // Show based on content on larger screens
                  spaceBetween: 20,
                },
              }}
            >
              {Array.isArray(discountedProperty) &&
                discountedProperty.map((discountedProperty, index) => (
                  <div className="col-md-12">
                    <SwiperSlide key={index}>
                      <div className="discounted-deal-property-div">
                        <Link
                          to={`/property-detail/${discountedProperty.slug}`}
                          className="view-detail-btn-property-home-txt"
                        >
                          <img
                            src={discountedProperty.imageUrls}
                            className="discounted-property-img img-fluid "
                            alt={`Discounted property ${discountedProperty.name}`}
                          />
                        </Link>
                        <div className="disocunted-property-specs-div">
                          <p className="discounted-property-name">
                            <Link
                              to={`/property-detail/${discountedProperty.slug}`}
                              className="view-detail-btn-property-home-txt"
                            >
                              {discountedProperty.name}
                            </Link>
                          </p>
                          <p className="discounted-property-address-txt">
                            <FaLocationDot />
                            <span>{discountedProperty.address}</span>
                          </p>
                          <p className="discounted-property-BHK-txt">
                            <FaBuilding />
                            {discountedProperty.BHK &&
                            Array.isArray(discountedProperty.BHK) ? (
                              discountedProperty.BHK.map((bhk, idx) => (
                                <span key={idx}>
                                  {bhk}
                                  {idx < discountedProperty.BHK.length - 1 &&
                                    ", "}
                                </span>
                              ))
                            ) : (
                              <span>Loading data...</span>
                            )}{" "}
                            BHK
                          </p>
                          <p className="discounted-property-price">
                            <FaIndianRupeeSign />
                            <span>{discountedProperty.price}</span>
                          </p>
                          <div className="property-devloper-btn-home-div">
                            <Link
                              to={`/property-detail/${discountedProperty.slug}`}
                              className="view-detail-btn-property-home"
                            >
                              View Details
                            </Link>
                            <button
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              className="get-call-btn-property-home-page"
                              onClick={() =>
                                handleButtonClick(discountedProperty.name)
                              }
                            >
                              Enquire Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </div>
                ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* discounted deals  */}
      {/* Why choose us section  */}
      <WhyChooseUs />
      {/* Why choose us section  */}

      {/* developer section auto scroll  */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Top Builders in Mumbai</p>
            </div>
            <BuilderSlider />
          </div>
        </div>
      </section>
      {/* developer section auto scroll  */}
      {/* Mumbai Property Overview */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">
                Property in Mumbai | Premium Flats for Sale in 2026
              </p>
              <p className="home-page-developer-txt">
                Mumbai is more than just a city. Where dreams begin, and where
                millions arrive with hope in their hearts. Every corner tells a
                story of ambition, resilience, and the determination to build a
                better life.
              </p>
              <p className="home-page-developer-txt">
                From the first local train in the morning to the glowing skyline
                past midnight, Mumbai moves with a rhythm unlike anywhere else.
                A city defined by constant energy and forward momentum.
              </p>
              <p className="home-page-developer-txt">
                For many, owning a home in Mumbai represents far more than a
                property purchase. It reflects long-term security, a space to
                create lasting memories, and the fulfillment of a lifelong
                aspiration.
              </p>
              <p className="home-page-developer-txt">
                In 2026, Mumbai continues to stand as one of India’s most
                trusted and dynamic real estate markets. Strong housing demand,
                improved infrastructure, and major city upgrades continue to
                create excellent opportunities for both homebuyers and
                investors. Whether you want to buy a flat in Mumbai for your
                family or explore investment options, the market remains full of
                promise.
              </p>
              <p className="home-page-developer-txt">
                This is a good time to buy a flat in Navi Mumbai. Better
                infrastructure and future development are supporting strong
                long-term value in these locations.
              </p>
              <p className="subheading-txt">
                Mumbai Real Estate Market in 2026: Key Highlights
              </p>
              <p className="home-page-developer-txt">
                1. Strong Demand Across Segments
              </p>
              <p className="home-page-developer-txt">
                Mumbai continues to see healthy demand across all price
                categories:
              </p>
              <ul>
                <li>Luxury homes in South Mumbai, Bandra, Worli, and BKC</li>
                <li>
                  Mid-segment homes in Goregaon, Kandivali, Borivali, and
                  Vikhroli
                </li>
                <li>
                  Affordable housing and flats in Navi Mumbai, Mira Road, and
                  Thane fringe
                </li>
              </ul>
              <p className="home-page-developer-txt">
                March 2026 recorded one of the highest monthly property
                registrations, reflecting strong buyer confidence and continued
                market momentum.
              </p>
              <p className="home-page-developer-txt">
                2. Infrastructure Driving Growth
              </p>
              <p className="home-page-developer-txt">
                Major infrastructure projects are improving travel access and
                boosting property values:
              </p>
              <ul>
                <li>Mumbai Coastal Road</li>
                <li>Metro Lines expansion</li>
                <li>Mumbai Trans Harbour Link</li>
                <li>Eastern Freeway and suburban corridor upgrades</li>
              </ul>
              <p className="home-page-developer-txt">
                These developments are reducing travel time and making suburban
                regions, especially Navi Mumbai, more attractive for buyers.
              </p>
              <p className="home-page-developer-txt">
                3. Redevelopment Reshaping Supply
              </p>
              <p className="home-page-developer-txt">
                With limited land availability in core Mumbai:
              </p>
              <ul>
                <li>
                  Builders are replacing older buildings across South Mumbai,
                  Chembur, Ghatkopar, and Andheri.
                </li>
                <li>
                  Buyers now have access to newer homes in prime,
                  well-established neighborhoods
                </li>
              </ul>
              <p className="home-page-developer-txt">
                This trend is improving housing quality while expanding supply
                in high-demand locations.
              </p>
              <p className="home-page-developer-txt">
                4. Healthy Sales and Inventory Absorption
              </p>
              <ul>
                <li>
                  New project launches remain strong, especially in Western
                  suburbs
                </li>
                <li>Unsold inventory has reduced significantly</li>
                <li>Prices continue to appreciate in key growth corridors</li>
              </ul>
              <p className="home-page-developer-txt">
                This makes 2026 a good time for those planning to buy flat in
                Mumbai before prices rise further.
              </p>
              <p className="subheading-txt">
                This makes 2026 a good time for those planning to buy flat in
                Mumbai before prices rise further.
              </p>
              <p className="home-page-developer-txt">Bandra / Worli</p>
              <p className="home-page-developer-txt">
                Perfect for luxury buyers seeking a premium lifestyle, sea
                views, and top-class amenities.
              </p>
              <p className="home-page-developer-txt">BKC</p>
              <p className="home-page-developer-txt">
                Ideal for professionals and investors looking for proximity to
                Mumbai’s leading business district.
              </p>
              <p className="home-page-developer-txt">Goregaon / Andheri</p>
              <p className="home-page-developer-txt">
                Great for families because of metro access, schools, offices,
                and entertainment options.
              </p>
              <p className="home-page-developer-txt">Borivali / Kandivali</p>
              <p className="home-page-developer-txt">
                Suitable for mid-budget buyers looking for value and balanced
                city access.
              </p>
              <p className="home-page-developer-txt">Vikhroli / Powai</p>
              <p className="home-page-developer-txt">
                Preferred by IT professionals because of easy travel access,
                modern townships, and strong rental demand.
              </p>
              <p className="home-page-developer-txt">Navi Mumbai</p>
              <p className="home-page-developer-txt">
                One of the most promising locations for buyers and investors.
                Families and working professionals are choosing flats in Navi
                Mumbai for better roads, planned development, and strong future
                growth.
              </p>
              <p className="subheading-txt">
                Why Mumbai Remains a Top Property Market
              </p>
              <p className="home-page-developer-txt">
                Mumbai’s real estate market benefits from a unique combination
                of emotional value and financial stability. Mumbai continues to
                attract buyers because of its strong job market, business
                opportunities, and steady population growth. Homebuyers choose
                Mumbai for reasons that go beyond convenience. They buy for
                security, future growth, and the confidence that their
                investment will remain relevant over time.
              </p>
              <p className="home-page-developer-txt">
                Mumbai remains a preferred property market because of the
                lifestyle it offers. The city gives residents easy access to top
                schools, hospitals, business hubs, entertainment zones, and
                daily essentials.
              </p>
              <ul>
                <li>Strong job market and economic growth</li>
                <li>High rental demand</li>
                <li>Excellent social infrastructure</li>
                <li>Better metro and road access</li>
                <li>Strong long-term appreciation potential</li>
              </ul>
              <p className="subheading-txt">Overall Outlook</p>
              <p className="home-page-developer-txt">
                Mumbai’s real estate market is expected to remain resilient
                throughout 2026. For homebuyers, this is the right time to
                explore both central and emerging growth corridors. For
                investors, areas near metro routes, business hubs, and
                developing suburbs offer solid long-term returns.
              </p>
              <p className="home-page-developer-txt">
                Mumbai and Navi Mumbai both offer strong growth, lifestyle
                benefits, and long-term value for homebuyers and investors.
              </p>
              <p className="home-page-developer-txt"></p>
              <p className="subheading-txt"></p>
            </div>
          </div>
        </div>
      </section>
      {/* Mumbai Property Overview */}
      {/* Review Section  */}
      <Testimonial />
      <Popup data={popupData} />
    </>
  );
};

export default Home;
